import React from "react";
import { Container } from "@/Components/Container";
import { ArrowLeft } from "react-feather";

/**
 *
 * @param children
 * @param header
 * @param byline
 * @param action - { label: string, callback: function} || JSX.Element
 * @param backAction - { label: string, callback: function}
 * @param preamble
 * @param icon - JSX.Element
 * @returns {JSX.Element}
 * @constructor
 */
export default function OrganizationLayout({
  children,
  header = "Organization settings",
  byline = null,
  action = null,
  backAction = null,
  preamble = null,
  icon = null,
}) {
  const isActionValid =
    React.isValidElement(action) ||
    (action &&
      typeof action === "object" &&
      action.hasOwnProperty("label") &&
      action.hasOwnProperty("callback"));

  const isBackActionValid =
    backAction &&
    typeof backAction === "object" &&
    backAction.hasOwnProperty("label") &&
    backAction.hasOwnProperty("callback");
  const isIconValid = React.isValidElement(icon);

  // Jimmy Approved, no unreadable oneliner please
  let headerMargin = "";
  if (!byline && !preamble) headerMargin = "mt-12";
  else if (byline && !preamble) headerMargin = "mb-2 mt-8";
  else if (!byline && preamble) headerMargin = "mt-2";
  else if (byline && preamble) headerMargin = "mb-2 mt-2";

  return (
    <>
      <Container
        size={"4xl:max-w-screen-3xl"}
        padding={"px-4 lg:px-16 4xl:pl-32 pb-8"}
        className={`4xl:mx-0 ${isBackActionValid ? "relative lg:-top-10" : ""}`}
      >
        {isBackActionValid && (
          <button
            className="mt-4 text-blue hover:underline lg:mb-4 lg:mt-0"
            onClick={backAction.callback}
          >
            <ArrowLeft size={16} className="-mt-0.5 inline" />
            &nbsp;{backAction.label}
          </button>
        )}
        <div className="flex items-start gap-4">
          {isIconValid && (
            <div className="hidden flex-shrink-0 pt-8 md:block">{icon}</div>
          )}
          <div className="flex grow justify-between max-sm:flex-col">
            <div>
              {preamble && <p className="mt-8">{preamble}</p>}
              <h1 className={`${headerMargin} text-5xl`}>{header}</h1>
              {byline && <p>{byline}</p>}
            </div>
            {isActionValid && (
              <div className="flex flex-col gap-4 max-sm:mt-4 sm:flex-row sm:items-end sm:justify-between">
                {isActionValid &&
                  (React.isValidElement(action) ? (
                    action
                  ) : (
                    <button
                      className="btn-blue shrink-0 grow-0"
                      onClick={action.callback}
                    >
                      {action.label}
                    </button>
                  ))}
              </div>
            )}
          </div>
        </div>
        <div className="mt-4">{children}</div>
      </Container>
    </>
  );
}
